// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mi-6","comment":"styles_comment__WDJkA"};